import {Utils} from '@astek/utils';
import {JsonConfigInterface} from './json-config-interface';

export type NumberStepConfigJson =  {
  value: number;
  maxRange: number;
};

export class NumberStepConfig implements JsonConfigInterface<NumberStepConfigJson> {

  private _value: number = 0;
  private _maxRange: number = 0;

  constructor(json?: NumberStepConfigJson) {
    if (!Utils.isNullOrUndefined(json)) {
      this.deserializeJson(json);
    }
  }

  public get value(): number {
    return this._value;
  }

  public get maxRange(): number {
    return this._maxRange;
  }

  public deserializeJson(json: NumberStepConfigJson): void {
    this._value = json.value;
    this._maxRange = json.maxRange;
  }
}
